import type { Translations } from '../../../types'

const shopEditorMessages: Translations = {
  "shop.editor.header.back": "Torna ai prodotti",
  "shop.editor.header.modeEdit": "Modalita modifica",
  "shop.editor.header.modeNew": "Nuovo inserimento",
  "shop.editor.header.typePill": "Tipologia: {{type}}",
  "shop.editor.header.changeType": "Cambia tipologia prodotto",
  "shop.editor.header.titleEdit": "Modifica prodotto",
  "shop.editor.header.titleNew": "Nuovo prodotto",
  "shop.editor.header.breadcrumb": "Catalogo / Prodotti",
  "shop.editor.header.subtitle": "Compila i campi core e usa i plugin catalogo per i campi verticali specifici del tuo ecommerce.",
  "shop.editor.tabs.navLabel": "Sezioni editor prodotto",
  "shop.editor.tabs.general": "Generale",
  "shop.editor.tabs.media": "Media",
  "shop.editor.tabs.pricing": "Prezzi",
  "shop.editor.tabs.variants": "Varianti",
  "shop.editor.tabs.extra": "Extra",
  "shop.editor.tabs.preview": "Anteprima",
  "shop.editor.preview.eyebrow": "Anteprima prodotto",
  "shop.editor.preview.subtitle": "Visualizzazione realistica della scheda prodotto lato shop.",
  "shop.editor.preview.desktop": "Desktop",
  "shop.editor.preview.mobile": "Mobile",
  "shop.editor.preview.imageAlt": "Immagine prodotto",
  "shop.editor.preview.thumbAlt": "Miniatura prodotto",
  "shop.editor.preview.noImage": "Immagine prodotto non disponibile",
  "shop.editor.preview.noCategory": "Categoria non assegnata",
  "shop.editor.preview.fallbackName": "Nome prodotto",
  "shop.editor.preview.priceLabel": "Prezzo",
  "shop.editor.preview.vatIncluded": "IVA incl.",
  "shop.editor.preview.stockLabel": "Disponibilità:",
  "shop.editor.preview.inStock": "{{count}} pezzi disponibili",
  "shop.editor.preview.outOfStock": "Esaurito",
  "shop.editor.preview.cta": "Aggiungi al carrello",
  "shop.editor.preview.descriptionLabel": "Descrizione",
  "shop.editor.preview.noDescription": "Aggiungi una descrizione per vedere il contenuto renderizzato.",
  "shop.editor.preview.specsLabel": "Specifiche",
  "shop.editor.preview.extraDetailsLabel": "Dettagli aggiuntivi",
  "shop.editor.preview.documentsLabel": "Documenti",
  "shop.editor.variants.emptyHint": "Aggiungi combinazioni prodotto per taglia, colore o specifiche dedicate.",
  "shop.editor.productType.warning": "Attenzione: cambiando tipologia, i campi non compatibili con la nuova tipologia verranno rimossi.",
  "shop.editor.basic.sectionEyebrow": "Informazioni principali",
  "shop.editor.basic.nameLabel": "Nome prodotto *",
  "shop.editor.basic.nameHint": "Campo principale: sara il titolo visibile in catalogo e scheda prodotto.",
  "shop.editor.basic.namePlaceholder": "Titolo prodotto",
  "shop.editor.basic.slugLabel": "Slug",
  "shop.editor.basic.slugPlaceholder": "slug-prodotto",
  "shop.editor.basic.descriptionLabel": "Descrizione",
  "shop.editor.basic.descriptionHelper": "Usa editor visuale o Markdown semplice (grassetto, corsivo, liste, link).",
  "shop.editor.basic.descriptionModeVisual": "Visuale",
  "shop.editor.basic.descriptionModeMarkdown": "Markdown",
  "shop.editor.basic.descriptionActionBold": "Grassetto",
  "shop.editor.basic.descriptionActionItalic": "Corsivo",
  "shop.editor.basic.descriptionActionHeading": "Titolo",
  "shop.editor.basic.descriptionActionList": "Elenco",
  "shop.editor.basic.descriptionActionLink": "Link",
  "shop.editor.basic.descriptionPreviewLabel": "Anteprima descrizione",
  "shop.editor.basic.descriptionPreviewEmpty": "Scrivi una descrizione per vedere l'anteprima.",
  "shop.editor.basic.descriptionPlaceholder": "Descrivi prodotto, materiali, compatibilita o punti di forza",
  "shop.editor.productTypeChange.title": "Cambia tipologia prodotto",
  "shop.editor.productTypeChange.subtitle": "Seleziona la nuova tipologia di prodotto.",
  "shop.editor.productTypeChange.currentBadge": "Tipologia attuale",
  "shop.editor.productTypeChange.pluginNone": "Plugin: {{plugin}}",
  "shop.editor.productTypeChange.pluginInfo": "Plugin: {{plugin}} • Campi: {{fields}}",
  "shop.editor.productTypeChange.noAlternatives": "Nessuna tipologia alternativa disponibile.",
  "shop.editor.productTypeChange.confirm": "Conferma cambio tipologia",
  "shop.editor.unsaved.title": "Ci sono modifiche non salvate",
  "shop.editor.unsaved.subtitle": "Hai apportato delle modifiche al prodotto corrente.",
  "shop.editor.unsaved.description": "Scegli come procedere prima di tornare alla lista prodotti.",
  "shop.editor.unsaved.warning": "Se esci senza salvare, tutte le modifiche dell'editor andranno perse.",
  "shop.editor.unsaved.continue": "Continua modifica",
  "shop.editor.unsaved.discard": "Esci senza salvare",
  "shop.editor.unsaved.saving": "Salvataggio...",
  "shop.editor.unsaved.saveAndExit": "Salva e torna ai prodotti",
  "shop.editor.messages.selectProductTypeBeforeSave": "Seleziona una tipologia prodotto prima di salvare",
  "shop.editor.messages.fillRequiredFields": "Compila i campi obbligatori prima di salvare",
  "shop.editor.messages.saveSuccess": "Prodotto salvato",
  "shop.editor.messages.saveError": "Salvataggio prodotto fallito",
  "shop.editor.messages.deleteConfirm": "Eliminare il prodotto \"{{name}}\"?",
  "shop.editor.messages.deleteSuccess": "Prodotto eliminato",
  "shop.editor.messages.deleteError": "Eliminazione prodotto fallita",
  "shop.editor.messages.noCompatibleFiles": "Nessun file compatibile con il campo \"{{field}}\"",
  "shop.editor.messages.customFieldUploadError": "Upload \"{{field}}\" fallito",
  "shop.editor.messages.customFieldUploadSuccessOne": "\"{{field}}\" caricato",
  "shop.editor.messages.customFieldUploadSuccessMany": "{{count}} file caricati per \"{{field}}\"",
  "shop.editor.messages.historyLoadError": "Caricamento versioni prodotto fallito",
  "shop.editor.messages.historyClearSuccess": "Versioni prodotto cancellate",
  "shop.editor.messages.historyClearError": "Cancellazione versioni prodotto fallita",
  "shop.editor.messages.historyDeleteSuccess": "Revisione eliminata",
  "shop.editor.messages.historyDeleteError": "Eliminazione revisione fallita",
  "shop.editor.sidebar.publication": "Pubblicazione",
  "shop.editor.sidebar.currentStatus": "Stato corrente",
  "shop.editor.sidebar.saveState": "Stato bozza",
  "shop.editor.sidebar.statusDraft": "Bozza",
  "shop.editor.sidebar.statusActive": "Pubblicato",
  "shop.editor.sidebar.statusArchived": "Archiviato",
  "shop.editor.sidebar.saving": "Salvataggio...",
  "shop.editor.sidebar.saveDraft": "Salva",
  "shop.editor.sidebar.noChangesToSave": "Nessuna modifica da salvare",
  "shop.editor.sidebar.publishing": "Pubblicazione...",
  "shop.editor.sidebar.publish": "Pubblica",
  "shop.editor.sidebar.preview": "Anteprima prodotto",
  "shop.editor.sidebar.visitProduct": "Visita pagina prodotto",
  "shop.editor.sidebar.backToProducts": "Torna ai prodotti",
  "shop.editor.sidebar.additionalFieldsTop": "Campi aggiuntivi sidebar",
  "shop.editor.sidebar.additionalFieldsBottom": "Campi aggiuntivi sidebar (bottom)",
  "shop.editor.sidebar.extraFieldsPanel": "Campi plugin",
  "shop.editor.sidebar.tabExtras": "Campi extra",
  "shop.editor.sidebar.tabReview": "Revisioni",
  "shop.editor.sidebar.noExtraFields": "Nessun campo extra configurato per questa tipologia.",
  "shop.editor.sidebar.revisionsPill": "Revisioni",
  "shop.editor.sidebar.revisionsPanelTitle": "Revisioni prodotto",
  "shop.editor.sidebar.revisionsPanelHint": "Seleziona una revisione per vedere la differenza rispetto alla bozza corrente.",
  "shop.editor.sidebar.revisionsSelected": "Selezionata",
  "shop.editor.sidebar.revisionsDiffLabel": "Diff revisione:",
  "shop.editor.sidebar.revisionsNoDiff": "Nessuna differenza rispetto alla bozza corrente.",
  "shop.editor.sidebar.revisionsModalTitle": "Versioni prodotto",
  "shop.editor.sidebar.revisionsModalSubtitle": "Apri una versione per vedere differenze chiare rispetto alla bozza attuale.",
  "shop.editor.sidebar.revisionsModalEmpty": "Nessuna versione disponibile.",
  "shop.editor.sidebar.revisionsModalExpand": "Mostra differenze",
  "shop.editor.sidebar.revisionsModalCollapse": "Nascondi differenze",
  "shop.editor.sidebar.revisionsModalChangesCount": "{{count}} differenze",
  "shop.editor.sidebar.revisionsModalTableVersion": "Versione",
  "shop.editor.sidebar.revisionsModalTableDiffs": "Differenze",
  "shop.editor.sidebar.revisionsModalTableAction": "Azione",
  "shop.editor.sidebar.revisionsModalActions": "Azioni revisione",
  "shop.editor.sidebar.revisionsModalMainImage": "Immagine principale",
  "shop.editor.sidebar.revisionsModalNoMainImage": "Nessuna immagine",
  "shop.editor.sidebar.revisionsModalDiffTitle": "Differenze contenuto",
  "shop.editor.sidebar.revisionsModalRevisionLabel": "Versione selezionata",
  "shop.editor.sidebar.revisionsModalCurrentLabel": "Bozza attuale",
  "shop.editor.sidebar.categoriesTitle": "Categorie",
  "shop.editor.sidebar.categoriesSearchPlaceholder": "Cerca categoria per nome o slug...",
  "shop.editor.sidebar.categoriesEmpty": "Nessuna categoria trovata con questo filtro.",
  "shop.editor.sidebar.categoryPrimary": "Primaria",
  "shop.editor.sidebar.categoryMakePrimary": "Rendi primaria",
  "shop.editor.sidebar.categoriesSelectedLabel": "Selezionate:",
  "shop.editor.sidebar.changePreviewTitle": "Anteprima modifiche",
  "shop.editor.sidebar.changePreviewEmpty": "Nessuna modifica non salvata.",
  "shop.editor.sidebar.changeBeforeLabel": "Prima:",
  "shop.editor.sidebar.changeAfterLabel": "Dopo:",
  "shop.editor.sidebar.savedVersionsTitle": "Versioni salvate",
  "shop.editor.sidebar.savedVersionsClear": "Svuota",
  "shop.editor.sidebar.savedVersionsEmpty": "Nessuna versione disponibile.",
  "shop.editor.sidebar.savedVersionsRestore": "Ripristina",
  "shop.editor.sidebar.savedVersionsDelete": "Elimina revisione",
  "shop.editor.sidebar.savedVersionsDeleteConfirmTitle": "Eliminare questa revisione?",
  "shop.editor.sidebar.savedVersionsDeleteConfirmDescription": "La revisione del {{date}} verrà rimossa in modo definitivo.",
  "shop.editor.sidebar.savedVersionsRetention": "La cronologia viene salvata a database con retention automatica.",
  "shop.editor.sidebar.controlCenter": "Controllo pubblicazione",
  "shop.editor.sidebar.controlCenterHint": "Gestisci stato, pubblicazione e revisione rapida del prodotto.",
  "shop.editor.publishValidation.title": "Attenzione: campi obbligatori mancanti",
  "shop.editor.publishValidation.subtitle": "Prima di pubblicare completa i campi obbligatori indicati qui sotto.",
  "shop.editor.publishValidation.missingLabel": "Campi da completare",
  "shop.editor.publishValidation.continue": "Continua modifica",
  "shop.editor.publishValidation.saveDraft": "Salva come bozza",
  "shop.editor.publishValidation.saving": "Salvataggio...",
}

export default shopEditorMessages
